if (!customElements.get('side-cart')) {
  customElements.define('side-cart', class SideCart extends HTMLElement {
    constructor() {
      super();
      window.sideCart = this;
      this.progressLevels = [
        { threshold: parseFloat(this.dataset.tier1Threshold), message: `WAIT! GRAB EXTRA SAVINGS<br><b>ADD $%amount% MORE FOR ${this.dataset.tier1Label.toUpperCase()}</b>`},
        { threshold: parseFloat(this.dataset.tier2Threshold), message: `YOU UNLOCKED ${this.dataset.tier1Label.toUpperCase()}!<br><b>ADD $%amount% MORE FOR ${this.dataset.tier2Label.toUpperCase()}</b>`},
        { threshold: parseFloat(this.dataset.tier3Threshold), message: `YOU UNLOCKED ${this.dataset.tier2Label.toUpperCase()}!<br><b>ADD $%amount% MORE FOR ${this.dataset.tier3Label.toUpperCase()}</b>`},
        { threshold: Infinity, message: `CONGRATS! YOU UNLOCKED A <br><b>${this.dataset.tier3Label.toUpperCase()}</b>`}
      ];
      this.initCartItems();
      this.initRecommendedProducts();
      this.handleOutsideClick();
      this.updateProgressBar();
      this.updateItemsHeight();
      this.routeDiv = null;
      this.routeObserver = null;
      this.setupRoute();
    }

    setupRoute() {
      this.routeDiv = this.querySelector('.route-div');
      if (this.routeDiv) {
        this.initRouteWidget();
      }
    }

    updateProgressBar() {
      return false;
      const subtotalElement = this.querySelector('.side-cart__subtotal');
      if (!subtotalElement) {
        return;
      }
      const cartTotal = parseFloat(subtotalElement.querySelector('.sale-price')?.textContent.replace(/[^0-9.]/g, '') || subtotalElement.textContent.replace(/[^0-9.]/g, '')) || 0;
      const progressFill = this.querySelector('.progress-fill');
      const progressMessage = this.querySelector('.cart-progress-message');
      const progressLevels = this.querySelectorAll('.progress-level');
      
      let percentFill = 0;
      const tier1Threshold = parseFloat(this.dataset.tier1Threshold);
      const tier2Threshold = parseFloat(this.dataset.tier2Threshold);
      const tier3Threshold = parseFloat(this.dataset.tier3Threshold);
      const tier3Product = this.dataset.tier3Product.trim();
      const tier3ProductId = this.dataset.tier3ProductId.trim();

      if (cartTotal <= tier1Threshold) {
        percentFill = (cartTotal / tier1Threshold) * 30;
      } else if (cartTotal <= tier2Threshold) {
        percentFill = 30 + ((cartTotal - tier1Threshold) / (tier2Threshold - tier1Threshold)) * 20;
      } else if (cartTotal <= tier3Threshold) {
        percentFill = 50 + ((cartTotal - tier2Threshold) / (tier3Threshold - tier2Threshold)) * 50;
      } else {
        percentFill = 100;
      }
      
      progressFill.style.width = `${percentFill}%`;
      
      if (cartTotal >= tier3Threshold) {
        progressMessage.innerHTML = `CONGRATS! YOU UNLOCKED A <br><b>${this.dataset.tier3Label.toUpperCase()}</b>`;
        if (tier3Product && !this.querySelector(`.side-cart__item[data-pid="${tier3ProductId}"]`)) {
          this.addRecommendedProduct(tier3Product);
        }
      } else if ((cartTotal >= tier2Threshold) && tier2Threshold > 0) {
        const amountNeeded = (tier3Threshold - cartTotal).toFixed(2);
        progressMessage.innerHTML = `YOU UNLOCKED ${this.dataset.tier2Label.toUpperCase()}!<br><b>ADD $${amountNeeded} MORE FOR ${this.dataset.tier3Label.toUpperCase()}</b>`;
        if (tier3Product && this.querySelector(`.side-cart__item[data-pid="${tier3ProductId}"]`)) {
          this.removeProduct(tier3Product);
        }
      } else if (cartTotal >= tier1Threshold) {
        let amountNeeded = (tier2Threshold - cartTotal).toFixed(2);
        progressMessage.innerHTML = `YOU UNLOCKED ${this.dataset.tier1Label.toUpperCase()}!<br><b>ADD $${amountNeeded} MORE FOR ${this.dataset.tier2Label.toUpperCase()}</b>`;
        if(tier2Threshold == 0){
          amountNeeded = (tier3Threshold - cartTotal).toFixed(2);
          progressMessage.innerHTML = `YOU UNLOCKED ${this.dataset.tier1Label.toUpperCase()}!<br><b>ADD $${amountNeeded} MORE FOR ${this.dataset.tier3Label.toUpperCase()}</b>`;
        }
        if (tier3Product && this.querySelector(`.side-cart__item[data-pid="${tier3ProductId}"]`)) {
          this.removeProduct(tier3Product);
        }
      } else {
        const amountNeeded = (tier1Threshold - cartTotal).toFixed(2);
        progressMessage.innerHTML = `WAIT! GRAB EXTRA SAVINGS<br><b>ADD $${amountNeeded} MORE FOR ${this.dataset.tier1Label.toUpperCase()}</b>`;
        if (tier3Product && this.querySelector(`.side-cart__item[data-pid="${tier3ProductId}"]`)) {
          this.removeProduct(tier3Product);
        }
      }

      progressLevels.forEach(level => {
        const threshold = level.dataset.level === '1' ? tier1Threshold 
                      : level.dataset.level === '2' ? tier2Threshold 
                      : tier3Threshold;
        if (cartTotal >= threshold) {
          level.classList.add('achieved');
        } else {
          level.classList.remove('achieved');
        }
      });
    }

    initCartItems() {
      let _this = this;

      document.querySelector('[data-side-cart-open]').addEventListener('click', function(evt) {
        evt.preventDefault();
        _this.openCart();
      })

      let closeButton = this.querySelector('[data-side-cart-close]');
      closeButton.addEventListener('click', function(evt) {
        evt.preventDefault();
        _this.closeCart();
      })

      let quantities = this.querySelectorAll('.side-cart__item-quantity-input');
      quantities.forEach(function(quantityInput) {
        quantityInput.addEventListener('change', function(evt) {
          _this.itemUpdate(quantityInput);
        })
      })

      let removeButtons = this.querySelectorAll('[data-cart-remove-item]');
      removeButtons.forEach(function(removeButton) {
        removeButton.addEventListener('click', function(evt) {
          evt.preventDefault();
          let key = this.dataset.cartRemoveItem;
          _this.removeItem(key);
        })
      })

      let toggles = this.querySelectorAll('.toggle-checkbox');
      toggles.forEach(function(toggle) {
        toggle.addEventListener('change', function(evt) {
          let itemIndex = toggle.dataset.itemIndex;
          let subscriptionOptions = document.getElementById(`subscription-options-${itemIndex}`);
          let sellingPlanInput = document.getElementById(`selling-plan-input-${itemIndex}`);
          let itemId = toggle.getAttribute('data-item-id');
          if (toggle.checked == true) {
            subscriptionOptions.style.display = 'block';
            sellingPlanInput.value = subscriptionOptions.querySelector('.subscription-dropdown').value;
            _this.updateCartWithSellingPlan(itemIndex, sellingPlanInput.value, itemId);
          } else {
            subscriptionOptions.style.display = 'none';
            sellingPlanInput.value = '';
            _this.updateCartWithSellingPlan(itemIndex, '', itemId);
          }
        });
      });

      let subscriptionDropdowns = this.querySelectorAll('.subscription-dropdown');
      subscriptionDropdowns.forEach(function(dropdown) {
        dropdown.addEventListener('change', function(evt) {
          let itemIndex = dropdown.closest('.subscription-options').id.split('-').pop();
          let itemId = dropdown.closest('.subscription-options').getAttribute('data-item-id');
          let sellingPlanInput = document.getElementById(`selling-plan-input-${itemIndex}`);
          sellingPlanInput.value = dropdown.value;
          _this.updateCartWithSellingPlan(itemIndex, dropdown.value, itemId);
        });
      });

      const form = document.getElementById('cart');
      if (form) {
        form.addEventListener('submit', function(evt) {
          return true;
        });
      }
    }

    async updateCartWithSellingPlan(itemIndex, sellingPlanId, itemId) {

      const response = await fetch('/cart.js');
      const cart = await response.json();
      const item = cart.items.find(item => item.id == itemId);
      const body = JSON.stringify({
        id: `${item.id}`,
        quantity: `${item.quantity}`,
        selling_plan: sellingPlanId
      });

      console.log('Sending request to update cart with:', body);
      fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
        .then(response => response.json())
        .then(data => {
          if (data.errors) {
            console.error('Server-side error:', data.errors);
            return;
          }
    
          if (data && Array.isArray(data.items)) {
            const lineItem = data.items.find(item => item.id == itemIndex);
    
            if (lineItem) {
              const subscriptionElement = document.querySelector(`.side-cart__item[data-pid="${itemIndex}"] .side-cart__item-subscription`);
              if (subscriptionElement) {
                subscriptionElement.textContent = lineItem.selling_plan_allocation 
                  ? lineItem.selling_plan_allocation.selling_plan.name : '';
              }
    
              const priceElement = document.querySelector(`.side-cart__item[data-pid="${itemIndex}"] .side-cart__item-price`);
              if (priceElement) {
                priceElement.textContent = `$${(lineItem.final_line_price / 100).toFixed(2)}`;
              }
            }
    
            this.reloadCart();
          } else {
            console.error('Error updating cart with selling plan: data.items is not an array or data is invalid', data);
          }

          var variantPopup = document.querySelector('.product-upsell-popup');
          sideCart.reloadCart();
          sideCart.openCart();
          variantPopup.classList.remove('active');
          if(variantPopup && popupvariantIDs.includes(data.id)){
            variantPopup.classList.add('active');
          }
        })
        .catch(error => {
          console.error('Error updating cart with selling plan:', error);
        });
    }

    initRecommendedProducts() {
      const addButtons = this.querySelectorAll('.side-cart__atc button');
      addButtons.forEach((addButton) => {
        addButton.addEventListener('click', (evt) => {
          evt.preventDefault();
          const recommendedProductElement = addButton.closest('.side-cart__item');
          const productId = recommendedProductElement ? recommendedProductElement.dataset.recommendedPid : null;
          if (productId) {
            this.addRecommendedProduct(productId);
          } else {
            console.error('Recommended Product ID not found');
          }
        });
      });

      $('.recommend-products').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        adaptiveHeight: true
      });
    }

    handleOutsideClick() {
      document.addEventListener('click', (event) => {
        const isOutsideClick = !this.contains(event.target) && !event.target.closest('[data-side-cart-open]');
        if (isOutsideClick && this.classList.contains('open')) {
          this.closeCart();
        }
      });
    }

    addRecommendedProduct(productId) {
      const addButton = this.querySelector(`.side-cart__item[data-recommended-pid="${productId}"] .side-cart__atc button`);
      if (addButton) {
        this.toggleButtonState(addButton, true);
      }
      const body = JSON.stringify({ id: productId, quantity: 1 });
      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => {
          return response.json().then((parsedState) => {
            console.log('Parsed state:', parsedState);
            if (!response.ok) {
              console.error('Error adding recommended product to cart:', parsedState.message || 'Unknown error');
              if (addButton) {
                this.toggleButtonState(addButton, false);
              }
            } else {
              this.reloadCart(() => {
                if (addButton) {
                  this.toggleButtonState(addButton, false);
                }
                $('.recommend-products').slick('setPosition');
              });
            }
          });
        })
        .catch((error) => {
          console.error('Error adding recommended product to cart:', error);
          if (addButton){
            this.toggleButtonState(addButton, false);
          }
        });
    }

    removeProduct(productId) {
      const body = JSON.stringify({ id: productId, quantity: 0 });
      fetch(`${routes.cart_change_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => {
          return response.json().then((parsedState) => {
            console.log('Parsed state:', parsedState);
            if (!response.ok) {
              console.error('Error removing product from cart:', parsedState.message || 'Unknown error');
            } else {
              this.reloadCart();
            }
          });
        })
        .catch((error) => {
          console.error('Error removing product from cart:', error);
        });
    }

    toggleButtonState(button, isLoading) {
      if (isLoading) {
        button.setAttribute('disabled', true);
        button.classList.add('loading');
      } else {
        button.removeAttribute('disabled');
        button.classList.remove('loading');
      }
    }

    openCart() {
      this.classList.add('open');
      document.querySelector('body').classList.add('cart-open');
      this.updateItemsHeight();
    }

    closeCart() {
      this.classList.remove('open');
      document.querySelector('body').classList.remove('cart-open');
    }

    itemUpdate(quantityInput) {
      let _this = this;
      let value = quantityInput.value;
      let index = quantityInput.dataset['item'];
      const body = JSON.stringify({
        "line": index,
        "quantity": value
      })

      fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
          console.log(response);
        })
      setTimeout(function() {
        _this.reloadCart();
      }, 600);
    }

    reloadCart(callback) {
      let _this = this;

      fetch('/account/login')
        .then((response) => response.text())
        .then(function (responseText) {
          var fetchedHTML = new DOMParser().parseFromString(responseText, 'text/html');
          var cartForm = document.querySelector('form#cart');
          
          if (cartForm) {
            const newCart = fetchedHTML.querySelector('form#cart');
            // Remove route div from new cart to prevent duplication
            const newRouteDiv = newCart.querySelector('.route-div');
            if (newRouteDiv) {
              newRouteDiv.remove();
            }

            cartForm.innerHTML = newCart.innerHTML;

            // Restore route div
            if (_this.routeDiv) {
              const footer = _this.querySelector('.side-cart__footer');
              if (footer) {
                footer.insertBefore(_this.routeDiv, footer.firstChild);
              }
            }

            _this.initCartItems();
            _this.initRecommendedProducts();
            _this.updateProgressBar();
            _this.updateCartCount();
            _this.updateItemsHeight();

            if (callback) callback();
          }
        });
    }

    removeItem(key) {
      const body = JSON.stringify({
        'id': key,
        'quantity': 0
      });
      fetch(`${routes.cart_change_url}`, { ...fetchConfig('javascript'), ...{ body } })
        .then((response) => response.json())
        .then((parsedState) => {
          sideCart.reloadCart();
        })
    }

    updateCartCount() {
      fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          const cartIndicator = document.querySelector('.cart-indicator');
          if (cartIndicator) {
            cartIndicator.textContent = cart.item_count > 0 ? cart.item_count : '';
            if (cart.item_count > 0) {
              cartIndicator.classList.add('has-items');
            } else {
              cartIndicator.classList.remove('has-items');
            }
          }
        });
    }

    updateItemsHeight() {
      const header = this.querySelector('.side-cart__header');
      const footer = this.querySelector('.side-cart__footer');
      const items = this.querySelector('.side-cart__items');
      if (header && footer && items) {
        const headerHeight = header.offsetHeight;
        const footerHeight = footer.offsetHeight;
        items.style.height = `calc(100vh - ${headerHeight}px - ${footerHeight}px)`;
      }
    }

    initRouteWidget() {
      if (!this.routeDiv) return;

      // Clean up existing observer
      if (this.routeObserver) {
        this.routeObserver.disconnect();
      }

      this.routeObserver = new MutationObserver(() => {
        const routeProtection = this.routeDiv.querySelector('.pw-variant-optimal');
        const pwTitle = this.routeDiv.querySelector('.pw-title');
        
        if (routeProtection && !routeProtection.querySelector('.pw-route-image')) {
          this.appendRouteImage(routeProtection);
        }
        
        if (pwTitle && !pwTitle.querySelector('.pw-route-description')) {
          this.appendRouteDescription(pwTitle);
        }
      });

      this.routeObserver.observe(this.routeDiv, {
        childList: true,
        subtree: true
      });
    }

    appendRouteImage(routeProtection) {
      const customContent = document.createElement('div');
      customContent.className = 'pw-route-image';
      customContent.innerHTML = `
        <div class="route-addon-image">
          <img src="${this.dataset.addonImage}" alt="" loading="lazy" width="50" height="50">
        </div>
      `;
      
      routeProtection.appendChild(customContent);
    }

    appendRouteDescription(pwTitle) {
      const description = document.createElement('div');
      description.className = 'pw-route-description';
      description.innerHTML = this.dataset.addonDescription;
      
      pwTitle.appendChild(description);
    }
  });
}
